import { CurrencyExchangeTemplate } from "@/modules/template/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const CurrencyExchangeTemplatePage = ({ isEdit }: IOperationPageProps) => (
  <CurrencyExchangeTemplate isEdit={isEdit}/>
);
